// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"f5-z","colorTextValue":"g5-z","swatches":"h5-z","collapseLink":"i5-z","isCollapsed":"j5-z","dropdown":"k5-z","disabled":"l5-z"};